import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allStandards: [{}],
  standard: {},
  newStandard: {},
  updatedStandard: {},
  deletedStandard: {},
  allParts: [{}],
  standardParts: [{}],
  newStandardPart: {},
  deletedStandardPart: {},
  customerStandards: [{}],
  newCustomerStandardAccess: {},
  deletedCustomerStandardAccess: {},
  error: null,
};

const standardSlice = createSlice({
  name: 'standard',
  initialState,
  reducers: {
    setReducerError: (state, action) => {
      state.error = action.error;
    },
    setAllStandards: (state, action) => {
      state.allStandards = action.payload;
      state.error = null;
    },
    setStandard: (state, action) => {
      state.standard = action.payload;
      state.error = null;
    },
    setNewStandard: (state, action) => {
      state.newStandard = action.payload;
      state.error = null;
    },
    setUpdatedStandard: (state, action) => {
      state.updatedStandard = action.payload;
      state.error = null;
    },
    setDeletedStandard: (state, action) => {
      state.deletedStandard = action.payload;
      state.error = null;
    },
    setAllParts: (state, action) => {
      state.allParts = action.payload;
      state.error = null;
    },
    setStandardParts: (state, action) => {
      state.standardParts = action.payload;
      state.error = null;
    },
    setNewStandardPart: (state, action) => {
      state.newStandardPart = action.payload;
      state.error = null;
    },
    setDeletedStandardPart: (state, action) => {
      state.deletedStandardPart = action.payload;
      state.error = null;
    },
    setCustomerStandards: (state, action) => {
      state.customerStandards = action.payload;
      state.error = null;
    },
    setNewCustomerStandardAccess: (state, action) => {
      state.newCustomerStandardAccess = action.payload;
      state.error = null;
    },
    setDeletedCustomerStandardAccess: (state, action) => {
      state.deletedCustomerStandardAccess = action.payload;
      state.error = null;
    },
    setResetStd: () => {
      return initialState;
    },
  },
});

export const {
  setReducerError,
  setAllStandards,
  setStandard,
  setNewStandard,
  setUpdatedStandard,
  setDeletedStandard,
  setAllParts,
  setStandardParts,
  setNewStandardPart,
  setDeletedStandardPart,
  setCustomerStandards,
  setNewCustomerStandardAccess,
  setDeletedCustomerStandardAccess,
  setResetStd,
} = standardSlice.actions;

export default standardSlice.reducer;
